import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { LoginComponent } from "./features/login/components/login.component";
import { RateLimitExceededComponent } from "./features/rate-limit-exceeded/rate-limit-exceeded.component";
import { PageNotFoundComponent } from "./features/page-not-found/components/page-not-found.component";

const routes: Routes = [
  { path: "", component: LoginComponent },
  { path: "rate-limit-exceeded", component: RateLimitExceededComponent },
  {
    path: "super-admin",
    loadChildren: () => import("./features/super-admin/super-admin.module").then((m) => m.SuperAdminModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
